import {
  Ship, Cpu, Sprout, Truck, PackageCheck, Globe, FileText, Boxes,
  ShieldCheck, Cloud, Network, Code2, Smartphone, Headphones, Leaf,
  Tractor, Wheat, Warehouse, Plane, Building2, HardHat, Briefcase, Star,
} from "lucide-react";

// Icon registry — content stores iconName strings; resolve to components here.
export const ICONS = {
  Ship, Cpu, Sprout, Truck, PackageCheck, Globe, FileText, Boxes,
  ShieldCheck, Cloud, Network, Code2, Smartphone, Headphones, Leaf,
  Tractor, Wheat, Warehouse, Plane, Building2, HardHat, Briefcase, Star,
};

export const ICON_NAMES = Object.keys(ICONS);

export function getIcon(name) {
  return ICONS[name] || Star;
}

export const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_global-trade-hub-183/artifacts/ipxkds0e_C6EFB969-873F-4D17-918D-B35B7FD4D61E.png";
export const LOGO_DARK = "https://customer-assets.emergentagent.com/job_global-trade-hub-183/artifacts/aifsiqr9_87B0ED44-BA14-440C-BD92-6DBC4310F8B2.png";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export const PROJECT_CATEGORIES = ["All", "Import & Export", "IT Solutions", "Agricultural Solutions", "Logistics", "General Supply"];

// Fallback defaults used while content loads or if the API is unreachable.
export const DEFAULTS = {
  company: {
    name: "Domaleo Enterprise",
    tagline: "Connecting Markets. Delivering Solutions.",
    phone: "+233 59 388 8009",
    phones: ["+233 59 388 8009", "+233 27 600 0075"],
    whatsapp: "233593888009",
    email: "info@domaleogh.com",
    address: "Independence Avenue, Accra, Ghana",
    hours: [
      { day: "Monday – Friday", time: "8:00 AM – 6:00 PM" },
      { day: "Saturday", time: "9:00 AM – 2:00 PM" },
      { day: "Sunday", time: "Closed" },
    ],
    socials: [
      { name: "Facebook", url: "#" },
      { name: "LinkedIn", url: "#" },
      { name: "Instagram", url: "#" },
      { name: "X", url: "#" },
    ],
    mapEmbed: "https://www.google.com/maps?q=Independence+Avenue,+Accra,+Ghana&output=embed",
  },
  hero: {
    badge: "Accra, Ghana · Connecting Markets",
    title: "Trade. Technology. Agriculture. Logistics. One Trusted Partner.",
    subtitle: "Domaleo Enterprise delivers world-class business solutions through import & export, IT services, logistics, agricultural solutions, and general supply.",
    image: "https://images.unsplash.com/photo-1691591765923-3bd6f12f4209?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  },
  stats: [
    { label: "Years of Experience", value: 12, suffix: "+" },
    { label: "Successful Projects", value: 850, suffix: "+" },
    { label: "Happy Clients", value: 420, suffix: "+" },
    { label: "Countries Served", value: 35, suffix: "+" },
  ],
  services: [],
  whyChoose: [],
  industries: [],
  values: [],
  testimonials: [],
  projects: [],
  gallery: [],
};
